var _defs, _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconQuestTrackerMarker = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "icon-quest-tracker-marker_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159738",
  fill: "none",
  d: "M0 0h24v24H0z"
})))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 871",
  cx: 4,
  cy: 4,
  r: 4,
  transform: "translate(8 8)",
  fill: "#999"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Rectangle 159743",
  fill: "none",
  d: "M4 4h16v16H4z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27661"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 27641",
  clipPath: "url(#icon-quest-tracker-marker_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36574",
  d: "M12.386 2.919a9.466 9.466 0 016.731 2.805A9.49 9.49 0 105.269 18.695a9.489 9.489 0 017.117-15.776",
  fill: "#ffd469"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36575",
  d: "M19.114 5.725A9.49 9.49 0 015.265 18.691 9.49 9.49 0 1019.114 5.725",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36576",
  d: "M6.105 19.436A9.481 9.481 0 0019.846 6.677z",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36577",
  d: "M19.118 5.726A9.49 9.49 0 005.273 18.69a9.587 9.587 0 00.837.745L19.847 6.676a9.578 9.578 0 00-.728-.952",
  fill: "#ffc32c"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36578",
  d: "M22.365 10.316l1.28-1.195a11.894 11.894 0 00-.7-2.037l-1.17 1.088a10.408 10.408 0 01.589 2.144",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36579",
  d: "M5.303 20.083l-1.107 1.029a12.022 12.022 0 002.1 1.447l1.171-1.088a10.531 10.531 0 01-2.162-1.388",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36580",
  d: "M1.861 14.735l-1.22 1.134a12.012 12.012 0 003.555 5.243l1.107-1.029a10.524 10.524 0 01-3.442-5.348",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36581",
  d: "M7.468 21.471l-1.171 1.088a11.928 11.928 0 001.982.849l1.286-1.195a10.421 10.421 0 01-2.1-.742",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36582",
  d: "M21.776 8.171l1.17-1.087a11.984 11.984 0 00-1.286-2.2l-1.11 1.032a10.479 10.479 0 011.226 2.258",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36583",
  d: "M22.365 10.315a10.5 10.5 0 01-12.8 11.9L8.279 23.41A12 12 0 0023.652 9.123z",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36584",
  d: "M1.5 12a10.5 10.5 0 0113.97-9.911L16.692.952A12 12 0 00.641 15.869l1.22-1.134A10.475 10.475 0 011.5 12",
  fill: "#fab907"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36585",
  d: "M20.55 5.91l1.11-1.032A12.039 12.039 0 0016.692.949l-1.22 1.14a10.548 10.548 0 015.081 3.824",
  fill: "#ffcc29"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36586",
  d: "M11.701 1.156a10.5 10.5 0 1010.5 10.5 10.514 10.514 0 00-10.5-10.5m0 20a9.5 9.5 0 119.5-9.5 9.507 9.507 0 01-9.5 9.5",
  fill: "#d67f00"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36587",
  d: "M12 1.494a10.5 10.5 0 1010.5 10.5A10.514 10.514 0 0012 1.494m0 20a9.5 9.5 0 119.5-9.5 9.507 9.507 0 01-9.5 9.5",
  fill: "#f9a13a"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36588",
  d: "M16.849 10.363l-.167-.042-2.207-.55-1.3-2.075a.938.938 0 00-.444-.37.953.953 0 00-1.182.37l-1.3 2.075-2.374.592a.986.986 0 00-.5 1.546l1.573 1.874-.171 2.441a.951.951 0 00.549.929.941.941 0 00.766.026l2.268-.916 2.268.916a.959.959 0 001.315-.956l-.171-2.441 1.573-1.874a.959.959 0 00-.5-1.546",
  fill: "#f59c0f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36589",
  d: "M14.109 9.295l-1.3-2.075a.937.937 0 00-.444-.37 1.422 1.422 0 00-.668.383 19.4 19.4 0 00-1.355 2.465s-2.8.493-3.025.615c-.358.19-.405.466-.4.975a.946.946 0 00.093.145l1.573 1.874-.17 2.441a.951.951 0 00.549.929l7.351-6.832z",
  fill: "#fff18f"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36590",
  d: "M7.321 10.315c.229-.122 3.025-.615 3.025-.615a19.391 19.391 0 011.355-2.465 1.422 1.422 0 01.668-.383.953.953 0 00-1.182.37l-1.3 2.075-2.374.592a.954.954 0 00-.6 1.4c-.006-.509.041-.785.4-.975",
  fill: "#fffa99"
}), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 36591",
  d: "M16.483 9.889l-.167-.042-7.351 6.832a.941.941 0 00.766.026l2.268-.916 2.268.916a.959.959 0 001.315-.956l-.171-2.441 1.573-1.874a.959.959 0 00-.5-1.546",
  fill: "#ffe164"
})))));
export default __webpack_public_path__ + "static/icon-quest-tracker-marker.e204926a4b888bc1ee0f1d18a4701b7f.svg";
export { SvgIconQuestTrackerMarker as ReactComponent };